import { useContext, useEffect, useState } from 'react'
import { LangContext, MobileContext } from './context'
import { RestrictedContext } from './context'
import { UserContext } from './context'
import { SessionWSContext } from './context'
import { ListSessionsWSContext } from './context'
import { TrkptsWSContext } from './context'
import { ListBoardsContext } from './context'
import { ListSailsContext } from './context'

export const useMobile = () => {
  const { mobile } = useContext(MobileContext)
  return { mobile }
}

export const useFetch = (fetchDatas) => {
  const [data, setData] = useState(null)
  const [isLoading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (!fetchDatas) return

    setLoading(true)
    const url = fetchDatas.url
    const postData = fetchDatas.postData
    const dc = decodeURIComponent(document.cookie)
    const sdc = dc.split('=')[1]
    const ws = sdc.split(';')[0]
    fetch(url, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        authorization: 'ws ' + ws,
      },
      body: JSON.stringify(postData),
    })
      .then((response) => {
        response.json().then((data) => setData(data))
      })
      .catch((error) => {
        console.log(error)
        setError(true)
      })
      .finally(() => setLoading(false))
  }, [fetchDatas])
  return { isLoading, data, error }
}

export const useLang = () => {
  const { toggleLang, lang } = useContext(LangContext)
  return { toggleLang, lang }
}

export const useRestricted = () => {
  const { toggleRestricted, restricted } = useContext(RestrictedContext)
  return { toggleRestricted, restricted }
}

// export const useDb = () => {
//   const { toggleDb, db } = useContext(DbContext)
//   return { toggleDb, db }
// }

export const useUser = () => {
  const { changeUser, user } = useContext(UserContext)
  return { changeUser, user }
}

export const useSessionWS = () => {
  const { changeSessionWS, sessionWS } = useContext(SessionWSContext)
  return { changeSessionWS, sessionWS }
}

export const useListSessionsWS = () => {
  const { setListSessionsWS, listSessionsWS } = useContext(
    ListSessionsWSContext
  )
  return { setListSessionsWS, listSessionsWS }
}

export const useListBoards = () => {
  const { setListBoards, listBoards } = useContext(ListBoardsContext)
  return { setListBoards, listBoards }
}

export const useListSails = () => {
  const { setListSails, listSails } = useContext(ListSailsContext)
  return { setListSails, listSails }
}

export const useTrkptsWS = () => {
  const { changeTrkptsWS, trkptsWS } = useContext(TrkptsWSContext)
  return { changeTrkptsWS, trkptsWS }
}
